import React from 'react';
import GpyComponent from './GpyComponent'
import {_GPY} from '../../../env.js'

class GpyTeamList extends GpyComponent {
  constructor(props) {
      super(props);
      this.state = {
          gpyComponentID: super.getId(),
          selectedPlayer : {id:-1},
          disableRcvSelect: this.props.disableRcvSelect!==undefined&&this.props.disableRcvSelect==="true"?true:false,
          playerHighlight:"",
          additionalClass: (this.props.additionalClass!==undefined?this.props.additionalClass:""),
          roleSetup : this.props.roleSetup!==undefined?this.props.roleSetup:[],

          sorter: this.props.sorter===undefined? function (list) {
                       list.sort(function(a, b) {
                         if(a._config===undefined||b._config===undefined) return 0;

                         if(a._config.player!==undefined && b._config.player!==undefined) {
                           if(a._config.player && !b._config.player)return 0;
                           if(!a._config.player && b._config.player)return 1;
                         }
                         if(a._config.substitue!==undefined && b._config.substitue!==undefined) {
                           if(a._config.substitue && !b._config.substitue)return 0;
                           if(!a._config.substitue && b._config.substitue)return 1;
                         }
                         if(a._config.sortIndex!==undefined && b._config.sortIndex!==undefined) {
                           return a._config.sortIndex < b._config.sortIndex ? 0:1;
                         }
                         return 0;
                       });
                       return list;
              }:this.props.sorter,

      };
    }


    appendPlayerHighlight(str) {
      clearInterval(this.playerHighlightRemover);
      var newValue = this.state.playerHighlight+str;
      var found = false;
      this.state.sorter( this.props.game.players.Player.filter(p => p.vsRole === this.props.vsRole) ).map((p) => {
        if(p.numOrPos!==undefined && newValue!=="" && p.numOrPos.includes(this.state.playerHighlight)) {
          found = true;
        }
      });
      if(found) {
        this.setState({playerHighlight:newValue});
            this.playerHighlightRemover = setInterval( () => {
              clearInterval(this.playerHighlightRemover);
              this.setState({playerHighlight:""})
            },3000);
    } else {
      this.setState({playerHighlight:""});
    }


    }

    preparePlayer(p) {
      if(p.vsUiState === undefined || p.vsUiState === '') {
          p.vsUiState = '{"player":false, "substitue":false, "score":0, "pos": {"x": 10, "y": 10, "xp":5, "yp": 10}, "sortIndex" : 0 }';
      }
      p._config = JSON.parse(p.vsUiState);
    }

    doSelectPlayer(player){
      console.log(player.id,this.state.selectedPlayer.id);
      this.setState({playerHighlight:""});
      if(this.state.selectedPlayer.id === player.id) {
        this.setState( { selectedPlayer:{id:-1} } ,
          ()=>{
              if((this.props.scoreboard !== undefined && this.props.scoreboard.onDeselectPlayer !== undefined)){
              console.log(this.state.gpyComponentID,"call onDeselectPlayer");
              this.props.scoreboard.onDeselectPlayer(this.props.vsRole,player);
          }
        });
      } else {
        this.setState({selectedPlayer:player},()=>{
          if((this.props.scoreboard !== undefined && this.props.scoreboard.onSelectPlayer !== undefined)){
            console.log(this.state.gpyComponentID,"call onSelectPlayer");
            this.props.scoreboard.onSelectPlayer(player);
          }
        });
      }
    }


    onDeselectPlayer(player) {
      if(!this.state.disableRcvSelect) {
        if(this.state.selectedPlayer.id === player.id) {
          console.log(this.state.gpyComponentID,"DESELECT",player);
          this.setState({selectedPlayer:{id:-1}});
        }
      }
    }

    onSelectPlayer(player) {
      console.log("disableRcvSelect",this.state.disableRcvSelect);
      if(!this.state.disableRcvSelect) {
        console.log(this.state.gpyComponentID,"SELECT",player);
          if(player.vsRole === this.props.vsRole) {
            this.setState({selectedPlayer:player});
            return;
          }
          console.log("exclude",this.props.exclusionRoles,player.vsRole);
          if(this.props.exclusionRoles!==undefined && this.props.exclusionRoles.includes(player.vsRole)) {
            this.setState({selectedPlayer:{id:-1}},()=>{
                if(this.props.scoreboard !== undefined && this.props.scoreboard.onDeselectPlayer !== undefined){
                  console.log(this.state.gpyComponentID,"call++ onDeselectPlayer");
                  this.props.scoreboard.onDeselectPlayer(this.props.vsRole , undefined);
                }
            });
          }

      }
    }

    forceUnselectPlayer(){
      this.setState({selectedPlayer:{id:-1}});
    }

    refresh() {
      this.forceUpdate();
    }

    selectPlayerById(player){
      this.props.game.players.Player.filter(p => p.vsRole === this.props.vsRole).forEach((p) => {
        if(p.id === player.id) {
          this.setState( {selectedPlayer : player} );
        }
      });
    }

    componentDidMount(){
      if(this.props.scoreboard !== undefined && this.props.scoreboard.registerComponent !== undefined){
         this.props.scoreboard.registerComponent(this.props.stateName,this);
      };
    }

    onChangeValue(obj){
    }

    render () {
      var id_count = 1;
  		return (
        <>
        <div className="list-group p-0">
          {this.state.sorter(this.props.game.players.Player.filter(p => p.vsRole === this.props.vsRole)).map((p) =>

             <div className="row">
                <div className={"col pr-0"}>

                <button key={p.id}
                    style={p.numOrPos!==undefined && this.state.playerHighlight!==undefined && this.state.playerHighlight!=="" && p.numOrPos.includes(this.state.playerHighlight)?{backgroundColor:"#ffff00"}:{}}
                    onClick={this.doSelectPlayer.bind(this,p)}
                    className={(this.state.selectedPlayer.id === p.id?"list-group-item list-group-item-action list-group-item-"+(this.props.color!==undefined?this.props.color:"success")+" flex-column align-items-start pointer":"list-group-item list-group-item-action flex-column align-items-start pointer") + this.state.additionalClass + " p-1" }>
                           <small className="m-2">{p.numOrPos!==undefined&&p.numOrPos!==""?p.numOrPos+" ":""}{p.firstName!==undefined&&p.firstName!==""?p.firstName + " ": ""}{p.lastName}
                           {p.__events!==undefined?p.__events.map(e => {
                             if(e.type !== undefined) {
                               id_count++;
                               if(e.type === "SUBSTITUTION" ) {
                                 return (<span key={id_count} className="glyphicon glyphicon-sort p-1" aria-hidden="true"></span>);
                               }
                               var card = "yellow_card.png"
                               if(e.type === "YELLOW-RED CARD") {
                                 card = "yellow_red_card.png";
                               } else if(e.type === "RED CARD") {
                                 card = "red_card.png";
                               }
                               return (<img key={id_count} style={{maxWidth : '20px', maxHeight: '20px'}} src={_GPY.resource("game_type/SoccerFootball/"+card)} className="img-fluid p-1" alt="CARD"/>);
                             } else {
                               return "";
                             };
                           }):""}
                           </small>
                </button>
             </div>
            <div className={"col-"+(this.state.roleSetup.length)+" pl-0"}> <div class="btn-group" role="group">
            {this.state.roleSetup.map((rs)=>{
                if( this.props.scoreboard.getRoleSetup(rs.name) === p.id ) {
                  return (<button className="btn btn-sm btn-danger p-0" onClick={(e)=>{
                    this.props.scoreboard.setUserRole(rs.name,undefined);
                  }}>{rs.title}</button>);
                } else {
                  return (<button className="btn btn-sm btn-secondary" onClick={(e)=>{
                    //this.state.roleSetup.map((role) => this.props.scoreboard.setUserRole(role.name,undefined));
                    this.props.scoreboard.setUserRole(rs.name,p.id);
                  }}>{rs.title}</button>);
                }
             })
           }
           </div>
           </div>
           </div>
        )}
        </div>
        </>
  		);
    }
}
export default GpyTeamList;
